import { makeStyles } from '@material-ui/core/styles';
import { SelectProps } from './types';

const useStyles = makeStyles({
  root: {
    boxSizing: 'border-box',
    width: '100%',
    paddingLeft: '5px',
    paddingBottom: '0',
    height: (props: SelectProps) => props.height || '32px',
    backgroundColor: (props: SelectProps) => props.backgroundColor || '#fff',
    '& .status': {
      display: 'none'
    },
    '& .MuiSelect-icon': {
      fontSize: '20px',
      width: '16px',
      height: '16px',
      top: 'calc(50% - 8px)'
    },
    '& .MuiInputBase-input': {
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
      padding: '5px 0',
      height: (props: SelectProps) => props.height || '32px',
      lineHeight: (props: SelectProps) => props.height || '32px',
      color: (props: SelectProps) => props.selectedItemColor || '#6b6b6b'
    }
  }
});

export const itemStyle = makeStyles({
  container: {
    transition: '0.2s',
    transitionProperty: 'color, background-color',
    maxWidth: '100%',
    paddingLeft: '5px',
    overflow: 'hidden',
    '&:hover': {
      backgroundColor: (props: SelectProps) =>
        props.itemHoverBackgroundColor || '#d1f0e5',
      color: (props: SelectProps) => props.itemHoverColor || '#2f9271',
      '& > $var': {
        backgroundColor: '#3dba90',
        color: '#fff'
      }
    },
    '&.Mui-selected': {
      backgroundColor: (props: SelectProps) =>
        props.itemSelectedBackgroundColor || '#fff',
      color: (props: SelectProps) => props.itemSelectedColor || '#3dba90',
      '& > $var': {
        backgroundColor: '#3dba90',
        color: '#fff'
      }
    }
  },
  root: {
    padding: '0 5px',
    height: '30px',
    lineHeight: '30px',
    color: '#6b6b6b'
  },
  var: {
    display: 'inline-block',
    paddingLeft: '8px',
    paddingRight: '8px',
    maxWidth: 'calc(100% - 16px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#6b6b6b',
    backgroundColor: '#eee',
    borderRadius: '4px',
    transition: '0.2s',
    transitionProperty: 'color, background-color',
    '&::before': {
      content: '"# "'
    }
  }
});
export default useStyles;
